<template>
  <div id="layout">
    <layout-left />
    <div class="layout-content" :class="{ active: isCollapse }">
      <layout-main />
    </div>
  </div>
</template>
<script></script>
<style scoped>
.layout-content {
  position: relative;
  margin-left: 210px;
  transition: all 0.5s;
}
.layout-content.active {
  margin-left: 75px;
}
</style>

<script>
import LayoutLeft from './components/LayoutLeft';
import LayoutMain from './components/LayoutMain';

export default {
  components: {
    LayoutLeft,
    LayoutMain,
  },
  computed: {
    isCollapse() {
      return this.$store.state.Layout.isCollapse;
    },
  },
  methods: {},
};
</script>
